import { html } from 'lit-html';
import { KatLitElement } from './kat-lit-element';

export class KatLitFilteredElement extends KatLitElement {
  // https://stackoverflow.com/questions/74268235/set-lit-child-components-to-implicitly-target-lit-parent-component-slots
  constructor(public slot: string, public allowedTags?: string[]) {
    super();
  }

  protected createRenderRoot(): Element | ShadowRoot {
    return this;
  }

  protected render() {
    const elements = this.allowedTags?.map(tag => this.querySelectorAll(tag));
    return html`${elements}`;
  }
}
